export default "__VITE_ASSET__32b2c559__"